import React, { Component } from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../../stores/actionsList';
import { checkTranslation, conditionalWidth, getObject, imageAddress, pathMaker, setObject, timeToTimeAgo, translate } from "../../../utils/useful";
import HttpServices from "../../../utils/Http.services";
import FormViewer from "../../../components/FormViewer";
import ButtonAnimated from "../../../components/buttons/ButtonAnimated";
import CustomLoader from "../../../components/CustomLoader";
import Modal from "../../../components/Modal";
import SocketServices from "../../../utils/socket.services";
import { nanoid } from "nanoid";

class RequestsView extends Component {


    state = {
        data: [],
        currentPage: 0,
        limit: 10,
        isLoadingHandle: {},
        topicId: nanoid(10),
        fields: []
    }

    componentDidMount() {
        this.init()

        if (this.props.setHeader) {
            this.props.setHeader({
                // 'toolbar': null,
                // 'showToolbar': false,
                // topHeaderComponent: this.topHeaderComponent,
                // headerIdentityComponent: this.headerIdentityComponent,
                backAction: () => this.props.cancel()
            })

            setTimeout(() => {
                this.setState({ revealFixed: true }, () => {
                    this.props.setHeader("dummy", 1)
                })
            }, 50);
        }

        SocketServices.addTopic(this.state.topicId, null, 'notifUpdate', null, this.updateData)

    }

    componentDidUpdate(prevProps) {
        if (this.props.page !== prevProps.page) {
            this.init()
        }
    }

    componentWillUnmount() {
        SocketServices.removeTopic(this.state.topicId, null, 'notifUpdate')
    }


    headerIdentityComponent = () => {
        return (
            <div className='white d-flex flex-column' >
                <p className="text-semibold text-small">{checkTranslation(this.props.page?.title)}</p>
                <p className="text-semibold text-smallest">{translate(this.props.name)}</p>
            </div>
        )
    }

    updateData = (newData, type) => {

        if (newData && type == 'update') {

            let data = this.state.data

            data.forEach((oneData, index) => {
                if (oneData._id == newData._id) {
                    data[index] = newData
                }
            });

            this.setState({ data })
        }
    }


    topHeaderComponent = () => {
        return (
            <div className='flexc'>

                <div className='flexcc px-1'>
                    <button className={" px-3 py-2 flexc br-20 " + " add-element "} onClick={() => this.props.applyConfig()}>
                        {/* <img className='prd-1 ' width={22} src='/assets/icons/pagebuilder/plus-black.svg' /> */}
                        <p className='font-size-14 black weight-500' style={{ whiteSpace: 'nowrap' }}>{translate('Apply Config')}</p>
                    </button>
                </div>


                {/* <ButtonAnimated
                    iconwidth='24px'
                    onClick={this.state.isLoadingData ? () => { } : () => this.save()}
                    title='Save'
                    icon='/assets/icons/plus-white.svg'
                    textColor={this.props.colors?.iconInvert ? '#fff' : '#000'}
                    invert={!this.props.colors?.iconInvert}
                    bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
                    isLoading={this.state.isLoadingData}
                /> */}
            </div>
        )
    }


    init() {
        if (this.props.page) {

            // let fields = [...this.props.page?.headers]

            this.setState({ data: [] }, () => {
                this.fetchData(true)
            })
            this.setHeader()
        }
    }

    setHeader = () => {
        if (this.props.setHeader) {
            this.props.setHeader({
                'toolbar': null,
                'showToolbar': false,
                'title': this.props.page?.title,
                'subtitle': this.props.page?.subtitle,
                backAction: () => this.props.changePage('')
            })
        }
    }

    fetchData = (getCount) => {

        let page = this.props.page

        if (this.props.initData) {
            this.setState({ initData: this.props.initData })

        }

        if (page.fetchUrl) {
            this.setState({ isLoadingData: true })
            let body = {
                type: 'request',
                appletHub: this.props.variables?.appletHub,
                // hub: this.props.variables?.appletHub

            }

            // console.log(body)

            HttpServices.request(page.fetchUrl, body, (fetchResult, fetchError) => {


                // console.log(fetchResult, fetchError)


                this.setState({ isLoadingData: false })
                if (fetchError) {
                    this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                    return
                }

                this.setState({ data: fetchResult.info })

                if (fetchResult.count) {
                    this.setState({ totalCount: fetchResult.count })
                }
            })
        }
    }




    setData = (key, value, reference, cb) => {
        if (reference == 'RequestsView') {
            this.setState({ [key]: value }, () => {
                if (cb) {
                    cb()
                }
            })
        }
        else {
            if (this.props.setData) {
                this.props.setData(key, value, reference, () => {
                })
            }
        }
    }
    changePage = (page) => {
        if (this.props.changePage) {
            this.props.changePage(page)
        }
        if (this.props.cancel) {
            this.props.cancel()
        }
    }



    handleRequest = (item, accept) => {

        let isLoadingHandle = this.state.isLoadingHandle ?? {}

        if (!isLoadingHandle[item._id]) {
            isLoadingHandle[item._id] = accept ? '1' : '0'
            this.setState({ isLoadingHandle })

            switch (item.topic) {
                case 'invitation': {
                    let body = { _id: item.extra._id, notif: item._id, accept }
                    HttpServices.request('handleInvitationRequest', body, (fetchResult, fetchError) => {

                        isLoadingHandle[item._id] = null
                        this.setState({ isLoadingHandle })

                        if (fetchError) {
                            this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                            return
                        }

                        let data = this.state.data
                        data.forEach(element => {
                            if (item._id == element._id) {
                                element.actionStatus = (accept ? 'A' : 'D')
                            }
                        })

                        this.setState({ data })

                    })
                    break;
                }


                default:

                    let data = { notif: item._id, accept }
                    HttpServices.request('handelRelationRequest', data, (fetchResult, fetchError) => {

                        isLoadingHandle[item._id] = null
                        this.setState({ isLoadingHandle })

                        if (fetchError) {
                            return
                        }

                        let data = this.state.data
                        data.forEach(element => {
                            if (item._id == element._id) {
                                element.actionStatus = (accept ? 'A' : 'D')
                            }
                        })

                        this.setState({ data })
                    })
                    break;
            }

        }

    }

    openFormInformation = (item) => {

        let currentFormInfo = item.form
        let currentFromFeilds = []

        if (item.connectionType?.form && item.connectionType?.form[0]?.pageContent) {
            item.connectionType?.form[0]?.pageContent.forEach(pageContent => {

                pageContent.sectionContent.forEach(sectionContent => {

                    sectionContent.rowContent.forEach(rowContent => {
                        rowContent.information.disabled = true
                        currentFromFeilds.push(rowContent)
                    });

                });


            });
        }

        this.setState({ currentFormInfo, currentFromFeilds }, () => {
            this.infoModal.showModal()
        })
    }



    renderConnectionRequest = (item) => {

        return (
            <div className={" pt-2 pb-2 mb-1 w-100 justify-content-between " + (conditionalWidth(this.props.width, { xs: '', sm: 'd-flex' }))} style={{ transition: 'all 0.5s', borderBottom: '0px solid #eee' }}>

                <div className={" flexc prd-2"} style={{ alignItems: 'flex-start' }}>
                    {/* <div className="" style={{}}> */}
                    <button onClick={() => { this.props.addNewWindow("hub", { path: [item.sender.username], type: 'hub' }, "center") }}>
                        <img className="mr-2" src={imageAddress(item?.sender?.image, 'profile')} style={{ width: '40px', height: 40, borderRadius: 40, objectFit: 'cover' }} />
                    </button>
                    <div>
                        <p className="font-size-14 weight-600">{item?.sender?.fullname}</p>
                        <p className="font-size-13 color-gray-2">@{item?.sender?.username}</p>

                        <p className="font-size-14">{item.message ? checkTranslation(item.message) : translate('invite you')}</p>

                        {item.connectionType && (
                            <div className="flexc font-size-13 mt-1">
                                <p className="text-semibold">{translate("Connection type")}</p>
                                <div className="flexcc mld-2">
                                    <p className="font-size-12  br-20 px-2 py-1 text-semibold" style={{ backgroundColor: '#007aff20', color: '#007aff' }}>{item.connectionType?.name}</p>
                                </div>
                            </div>
                        )}

                        {item.form && (
                            <button onClick={() => this.openFormInformation(item)}>
                                <p className="font-size-13 text-link">{translate("View form information")}</p>
                            </button>
                        )}
                        {/* <p className="font-size-12">{timeToTimeAgo(item.cDate)}</p> */}
                        {/* <p className="text-small pb-1" style={{ fontWeight: 'bold' }}>{item.extra.type}</p>
                        <p className="text-smaller">{moment(item.cDate).format('DD MMMM YYYY')}</p>
                        <p className="text-smaller" style={{ cursor: 'pointer' }}>view more...</p> */}

                    </div>
                    {/* </div> */}
                </div>

                <div className={"flexce " + (conditionalWidth(this.props.width, { xs: 'mt-2', sm: 'mt-0' }))}>

                    {item.actionStatus == 'D' && (
                        <div className="br-20 px-3 py-2" style={{ color: '#ee5050', backgroundColor: "#ee505020" }}>
                            <p className="font-size-13 text-semibold">{translate("Declined")}</p>
                        </div>

                    )}

                    {item.actionStatus == 'A' && (
                        <div className="br-20 px-3 py-2" style={{ color: '#007aff', backgroundColor: "#007aff20" }}>
                            <p className="font-size-13 text-semibold">{translate("Accepted")}</p>
                        </div>

                    )}

                    {item.actionStatus == null && (
                        <>
                            <div className="flexc mrd-2">
                                <ButtonAnimated
                                    onClick={() => this.handleRequest(item, false)}
                                    title={translate('Decline')}
                                    isLoading={this.state?.isLoadingHandle[item._id] == '0'}
                                    textColor={'#777'}
                                    bg={'#e0e0e0'}
                                    width={'100%'}
                                />
                            </div>
                            <div className="flexc">
                                <ButtonAnimated
                                    iconwidth='24px'
                                    onClick={() => this.handleRequest(item, true)}
                                    title={translate('Accept')}
                                    icon='/assets/icons/check-white.svg'
                                    textColor={'#fff'}
                                    isLoading={this.state?.isLoadingHandle[item._id] == '1'}
                                    bg={this.props.background ?? ' linear-gradient(90deg, #3062D4, #3062D4)'}
                                    width={'100%'}
                                />
                            </div>
                            {/* <button className="w-100 flexcc mr-1 br-6 " style={{ padding: '6px 2px 6px 2px', maxWidth: '70px', background: '#3062D4', color: '#fff', cursor: 'pointer' }} onClick={() => this.handleRequest(item, true)}>
                        <p style={{ color: '#fff' }}>Accept</p>
                    </button>
                    <button className="w-100 flexcc ml-1 br-6 px-1" style={{ padding: '4px 2px 4px 2px', border: '1px solid #D3D9DE', maxWidth: '60px', background: '#fff', cursor: 'pointer' }} onClick={() => this.handleRequest(item, false)}>
                        <p style={{ color: '#000' }}>Deny</p>
                    </button> */}
                        </>
                    )}
                </div>

            </div>
        )
    }


    render() {

        let variables = this.props.variables
        if (!variables) {
            variables = {}
        }
        let background = `linear-gradient(90deg, ${this.props.colors?.primaryColor}, ${this.props.colors?.secondaryColor})`
        let hub = this.props.variables?.appletHub
        let requests = this.props.inbox?.categorizer?.request?.hubs ? this.props.inbox?.categorizer?.request?.hubs[hub] : null

        return (
            <div className="h-100 sc-gray4" style={{ backgroundColor: '#f0f0f0', overflow: 'auto' }}>
                <div className=" " >
                    <div className="row m-0">
                        <div className=" mb-5 mt-2 w-100 p-2 flexc flex-column">
                            <div className="p-3 px-4 " style={{ width: '100%', maxWidth: 600, backgroundColor: '#fff', borderRadius: 20 }}>
                                {this.state.isLoadingData && (
                                    <div className="flexcc flex-column py-5">
                                        <CustomLoader color={"#007aff"} isLoading={true} width={30} height={30} />
                                        <p className="text-smaller mt-1 color-gray-3">{translate("is Loading ...")}</p>
                                    </div>
                                )}
                                {!this.state.isLoadingData && (
                                    <>
                                        <div className="px-2 mb-4" >
                                            <div className="p-0" style={{ borderRadius: 0 }}>
                                                <div className="flexcb" style={{ flexWrap: 'wrap' }}>
                                                    <div className="flexc mt-2  w-100">
                                                        <div className="flexc w-100">
                                                            <p className="text-semibig text-bold m-0 " style={{ color: '#000' }}>{checkTranslation(this.props.page?.title)}</p>
                                                            {requests?.count > 0 && (
                                                                <div className="flexcc">
                                                                    <div className='white flexcc mld-2 px-1' style={{ borderRadius: 20, minWidth: 20, height: 20, lineHeight: 1, backgroundColor: '#ee5050', right: 0 }}>
                                                                        <span className='font-size-12'>{requests?.count}</span>
                                                                    </div>
                                                                </div>
                                                            )}
                                                            {/* <p className="text-small m-0" style={{ color: '#89a' }} >{checkTranslation(this.props.page?.description)}</p> */}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {this.state.data?.length == 0 && (
                                                <div className="px-2 py-5">
                                                    <p style={{ textAlign: 'center', margin: 0, color: '#000', opacity: 0.5, fontSize: 13 }}>{translate("useful.foundNothing")}</p>
                                                </div>
                                            )}
                                            <div className="mt-3">
                                                {this.state.data?.map((item, index) => {
                                                    return (
                                                        <>
                                                            {this.renderConnectionRequest(item)}
                                                        </>
                                                    )
                                                })}
                                            </div>
                                        </div>

                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>


                <Modal width={this.props.width} ref={el => this.infoModal = el} hideOverlay={false} maxWidth={400} widthCondition={{ xs: "100%", sm: "100%", md: '50%', lg: "33.3%", xl: "25%" }}>


                    <div stage={0} stageName="List" className="w-100 br-10 pb-3 " style={{ backgroundColor: "white" }} >
                        <div className="d-flex flex-column px-3 pt-2 pb-2 top-0" style={{ borderRadius: '10px 10px 0px 0px', position: 'sticky', background: '#fff', borderBottom: '1px solid #eee' }}>
                            <p className="font-size-18 text-semibold py-1">From information</p>
                        </div>

                        <div className="pt-3">
                            <FormViewer ref={el => this.formInfo = el} headers={this.state.currentFromFeilds} initData={this.state.currentFormInfo} formClass={'bordered-form'} inputClass={'bordered-input '} variables={this.props.variables} />
                        </div>

                    </div>

                </Modal>

            </div>
        )
    }
}



const mapStateToProps = state => ({ settings: state.settings, user: state.user, inbox: state.inbox })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { forwardRef: true }
)(RequestsView);